import { FC, SVGProps } from 'react'

export const Branch: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.288 14.4553L13.9777 11.7656M13.9777 11.7656L11.288 9.07591M13.9777 11.7656H7.5224L5.37057 8H1.60498"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.9777 4.23442H7.5224L5.37057 8.00002H1.60498M13.9777 4.23442L11.288 6.92411M13.9777 4.23442L11.288 1.54468"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
